import React from "react";
import "./Home.css";
import Gitbub from "../../img/github.png";
import LinkedIn from "../../img/linkedin.png";
import Instagram from "../../img/instagram.png";

import { themeContext } from "../../Context";
import { useContext } from "react";
// import Typed from 'react-typed'
import Cv from "../../img/fw20_0863_Vipul_Vatsa_Resume.pdf";
import img1 from "../../img/img1_latest.jpg"



function Home() {
  const theme = useContext(themeContext);
  const darkMode = theme.state.darkMode;
  return (
    <div id="home"  className="home w-100 row">
      <div className="h-left p-0 m-0 col-12 col-md-12 col-lg-6">
        <div className="h-name">
          <span className="name-details" style={{ color: darkMode ? "white" : "black"  }}>Hello! I'm </span>
          <span className="name-details" >Vipul Vatsa</span>
          
          <span className="name-details"  style={{ color: darkMode ? "white" : "" }}>
          I'm a <span id="text" className="name-details"  style={{fontSize:"30px",color:"#09a672"}}>Full Stack Web Developer</span> with a strong passion for building responsive and performant web applications with great user experiences that positively impact the world.
          </span>
        </div>
        <div className="btn-home" >
        <a href={Cv} download>
            <button  className="button h-button">Resume</button>
          </a>
          
        
          
          
        </div>
        
      </div>
      <div
        className="image-pro"
        style={{ color: darkMode ? "black" : "black" }}
      >
        <img alt="" />
      
        <img src={img1} alt="image" style={{borderRadius:"50%",width:"300px",marginLeft:"20px",marginTop:"10px"}} />
       
      </div>
    </div>
  );
}

export default Home;
